module.exports = __webpack_public_path__ + "img/hiit.e7564b1d.jpg";